import { render, staticRenderFns } from "./qing.vue?vue&type=template&id=b63e5294&scoped=true"
import script from "./qing.vue?vue&type=script&lang=js"
export * from "./qing.vue?vue&type=script&lang=js"
import style0 from "./qing.vue?vue&type=style&index=0&id=b63e5294&prod&lang=scss"
import style1 from "./qing.vue?vue&type=style&index=1&id=b63e5294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63e5294",
  null
  
)

export default component.exports